// Menu.js
import styles from './Menu.module.css'
import { useLanguage } from '../contexts/LanguageContext'
import getData from './Model'
import MenuItem from './MenuItem'

function Menu(props){
    const { language } = useLanguage()
    const mainmenu = getData('mainmenu', language)
    
    if (!mainmenu){
        return <div>No data for mainmenu</div>
    } 
    
    return ( 
        <div className={styles.Menu}>
            <nav>
                {mainmenu.map((menuitem, index) => (
                    <MenuItem key={index} {...menuitem}></MenuItem>
                ))}
            </nav>
            <div>{props.children}</div>
        </div>
    )
}

export default Menu